import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";

export const SlackFormMessage = styled.div`
  color: ${color("text-medium")};
  margin: 2rem 0 1rem;
`;
